// extracted by mini-css-extract-plugin
export var container = "_pc-0";
export var dotAnimation = "_pc-2";
export var dotsLoading = "_pc-1";